export default class RelatedByDate {
  date: string = '';
  data: Array<any> = [];
}
